import styled from '@emotion/styled'
import FusionLogo from '../../art/Logo'
import { LibraryIconProp } from '@fusion-advantage/formlib'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const V2L3PrintPageHeaderRoot = styled.div(({theme}) => ({
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr max-content',
	columnGap: theme.spacing(4),
	alignItems: 'center',
	paddingBottom: theme.spacing(3),
	// 20251212 DAN'S PRINT HACKS FOR APPEASING CUSTOMERS
	// borderBottom: `1px solid ${theme.colors.black}`,
}))

const Content = styled.div({
	lineHeight: '1.4em',
})

const PatientName = styled.div({
	fontWeight: 'bold',
})

const EncounterDetail = styled.div({

})

// const Tab = styled.div(({theme}) => (({
// 	display: 'flex',
// 	flexDirection: 'row',
// 	columnGap: theme.spacing(2),
// 	backgroundColor: theme.colors.pdfGray,
// 	boxSizing: 'border-box',
// 	minWidth: theme.spacing(24),
// 	padding: theme.spacing(2),
// 	borderRadius: theme.borderRadius,
// 	alignItems: 'center',
// 	justifyContent: 'center',
// 	fontSize: '20px',
// })))

// const TabTitle = styled.div(({theme}) => (({
// 	...theme.fonts.titleBold,
// })))

const SizedLogo = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '133.3px',
	height: '67px',
	overflow: 'hidden',
	'> img': {
		width: '100%',
		height: '100%',
		objectFit: 'contain',
	},
})

interface V2L3PrintPageHeaderProps {
	isFirstPage: boolean
	patientName?: string
	encounterDetail?: string
	tabIcon?: IconProp|LibraryIconProp
	tabTitle?: string
	logoSrc?: string
}

export const V2L3PrintPageHeader = ({isFirstPage, patientName, encounterDetail, logoSrc}: V2L3PrintPageHeaderProps) => {
	return (
		<V2L3PrintPageHeaderRoot>
			{isFirstPage ? (
				<>
					<SizedLogo>
						{logoSrc ? <img src={logoSrc} /> : <FusionLogo />}
					</SizedLogo>
					<Content>
						<PatientName>{patientName}</PatientName>
						<EncounterDetail>{encounterDetail}</EncounterDetail>
					</Content>
				</>
			) : (
				<>
					<div />
					<div />
				</>
			)}
			{/* // 20251212 DAN'S PRINT HACKS FOR APPEASING CUSTOMERS
				<Tab>
					<FontAwesomeIcon icon={tabIcon as IconProp} />
					<TabTitle>{tabTitle}</TabTitle>
				</Tab>
			*/}
		</V2L3PrintPageHeaderRoot>
	)
}
